module.exports = __webpack_public_path__ + "img/logoin.35f5770e.png";